import { CheckCircle2, ShieldAlert, XCircle } from "lucide-react";
import { cn } from "@/lib/utils";

export interface ReglaEvaluada {
  id: string;
  titulo: string;
  prioridad: string;
  cumple: boolean;
  detalle: string;
}

/** Impacto real que la plataforma aplica al score por cada regla incumplida. */
function impacto(prioridad: string): string {
  if (prioridad === "alta") return "Veto: score máximo 39 y veredicto No postular";
  if (prioridad === "media") return "Penalización de 10 puntos";
  return "Sólo advertencia, no afecta el score";
}

export function RulesPanel({ reglas }: { reglas: ReglaEvaluada[] }) {
  return (
    <section className="rounded-xl border border-border bg-card p-5 shadow-elegant">
      <header className="flex items-center gap-2 mb-3">
        <ShieldAlert className="size-4 text-primary" />
        <h3 className="font-display font-semibold">Reglas internas de la empresa</h3>
      </header>

      {reglas.length === 0 ? (
        <p className="rounded-lg border border-dashed border-border bg-muted/20 px-3 py-2 text-sm text-muted-foreground">
          No hay reglas internas evaluadas para esta oportunidad.
        </p>
      ) : (
        <ul className="grid gap-2.5 md:grid-cols-2 xl:grid-cols-3">

          {reglas.map((r) => (
            <li
              key={r.id}
              className={cn(
                "rounded-lg border p-3",
                r.cumple ? "border-border bg-muted/30" : "border-destructive/30 bg-destructive/5",
              )}
            >
              <div className="flex items-start gap-2">
                {r.cumple ? (
                  <CheckCircle2 className="size-4 text-success mt-0.5 shrink-0" />
                ) : (
                  <XCircle className="size-4 text-destructive mt-0.5 shrink-0" />
                )}
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="text-sm font-medium text-foreground">{r.titulo}</span>
                    <span className="text-[10px] uppercase tracking-wide px-1.5 py-0.5 rounded-full bg-muted text-muted-foreground">
                      Prioridad {r.prioridad}
                    </span>
                  </div>
                  {r.detalle && <p className="text-xs text-muted-foreground mt-1">{r.detalle}</p>}
                  {!r.cumple && (
                    <p className="text-[11px] text-destructive mt-1">{impacto(r.prioridad)}</p>
                  )}
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
